module.exports = __webpack_public_path__ + "img/about-main-min.a2d77ac8.jpg";